<template>
    <div>
        <v-card class="p-3 flex-fill h-100 w-100">
            <div class="d-flex justify-content-between">
                <h5>Destinataire Uska</h5>

                <div class="d-flex justify-content-between gap-10">
                    <v-btn outlined class="custom-button-primary"
                           style="height: 36px;min-width: 42px;padding: 0"
                           @click="openModal(contact)"
                           v-if="contact !== null"
                    >
                        <v-icon>edit</v-icon>
                    </v-btn>
                </div>
            </div>
            <div>
                <div class="mb-2" v-if="contact && contact.first_name !== null && contact.first_name !== undefined">
                    <v-icon class="text-primary" left>person</v-icon>
                    <span class="mt-auto mb-auto">{{ contact.first_name }} {{ contact.last_name }}</span>
                </div>
                <div class="mb-2" v-if="contact && contact.email !== null && contact.email !== undefined">
                    <v-icon class="text-primary" left>email</v-icon>
                    <span class="mt-auto mb-auto">{{ contact.email }}</span>
                </div>
                <div class="mb-2" v-if="contact && contact.phone !== null && contact.phone !== undefined">
                    <v-icon class="text-primary" left>phone</v-icon>
                    <span class="mt-auto mb-auto">{{ contact.phone }}</span>
                </div>
            </div>

            <div class="mb-2"
                 v-if="contact && contact.profession !== null && contact.profession !== undefined">
                <v-icon class="text-primary" left>work</v-icon>
                <span class="mt-auto mb-auto">{{ contact.profession.label }}</span>
            </div>
        </v-card>

        <v-dialog v-model="editModal" persistent max-width="900px" v-if="editModal && currentContact">
            <v-card>
                <v-card-title class="d-flex justify-content-between">
                    <div>
                        <span class="headline">Edition du contact</span>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field outlined label="Prénom" hide-details
                                          v-model="currentContact.first_name">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field outlined label="Nom" hide-details
                                          v-model="currentContact.last_name">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field outlined label="E-mail*" required
                                          hide-details v-model="currentContact.email">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <v-text-field outlined label="Téléphone" hide-details
                                          v-model="currentContact.phone">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-select :items="professions"
                                      outlined
                                      label=" Fonction"
                                      hide-details
                                      v-model="currentContact.profession"
                                      item-text="label"
                                      return-object>
                            </v-select>
                        </v-col>
                    </v-row>
                    <div class="d-flex justify-content-end gap-10">
                        <v-btn @click="editModal = false">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="updateContact">
                            Modifier le contact
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    name: "EntityContactBloc",
    props: ["contact", "entityId"],
    data() {
        return {
            editModal: false,
            professions: [],
            currentContact: {
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                profession: null,
            },
            selectedContact: null,
        }
    },
    methods: {
        openModal(contact) {
            if (this.contact !== null) {
                this.currentContact = JSON.parse(JSON.stringify(contact))
            }
            this.editModal = true
        },
        getProfessions() {
            this.$http.get("resource/professions").then(res => {
                this.professions = res.body.data.professions
            })
        },
        updateContact() {
            let payload = {
                contact: this.currentContact,
                entityId: this.entityId,
            }

            this.$http.put("auth/sit-entity/update-contact", payload).then(res => {
                if (res.body.success) {
                    this.editModal = false

                    this.$global.$emit("reload-entity")
                }
            })
        },
    },
    created() {
        this.getProfessions()
    },
}
</script>